export default __webpack_public_path__ + "static/media/sudeep.11269baf.png";